<template>
<div class="form-group" :class="[{ 'coff-input-error' : localError }]" :key="uuid">

    <label htmlFor="input">
        <b>{{$t(label)}}</b>
        <slot name="label"></slot>
    </label>

    <div class="input-group">
        <input type="text" :class="['p-inputtext p-component', { 'p-error' : localError }, {'p-filled': filled}]" v-on="listeners" :value="value" :id="uuid" :disabled="disable" />
        <span v-if="localError">{{ $t(localErrorMessage)}}</span>
    </div>

</div>
</template>

<script>
    import Utils from "@/utils/Utils";

    export default {
        name: "CoffInputEmail",

        props:{
            label: {type: String, default: null},
            value: null,
            error: {type: Boolean, default: false},
            errorMessage: {type: String, default: 'field.default.error'},
            id: null,
            disable: {type: Boolean, default: false},
            required: {type: Boolean, default: false},
        },

        data(){
            return {
                uuid: Utils.uuid(),
                localErrorMessage: this.errorMessage,
                localError: this.error,
            }
        },

        mounted() {
            if(this.id){
                this.uuid = this.id;
            }
        },

        computed: {
            listeners() {
                return {
                    ...this.$listeners,
                    input: event => this.$emit('input', event.target.value)
                };
            },
            filled() {
                return (this.value != null && this.value.toString().length > 0)
            }
        },

        methods: {

            emailValidation(erros = false){
                if(Utils.isEmptyNullOrUndefined(this.value) && this.required){
                    erros = true;
                    this.localError = true
                } else if (!Utils.isEmptyNullOrUndefined(this.value) && (this.value.indexOf('@') < 0 || this.value.indexOf('.') < 0)){
                    this.localErrorMessage = 'forms.email-invalid';
                    erros = true;
                    this.localError = true;
                } else if(!this.required) {
                 this.localError = false;
                }
                return erros;
            }

        }

    }
</script>

<style scoped>

</style>
